import PropTypes from 'prop-types'
import React from 'react'
import App from 'ui/App'

const Workspace = props => (
  <App currentPage={props.currentPage}>
    {props.children}
  </App>
)

Workspace.displayName = 'Workspace'

Workspace.propTypes = {
  currentPage: PropTypes.string,
  children: PropTypes.node
}

export default Workspace



// WEBPACK FOOTER //
// ./components/Workspace.js